import React, { Component } from 'react';
import { View, Text } from 'react-native';
import utils from '../utils';
import { enabledStyle, disabledStyle } from '../commonStyles';

const statusMap: { [propName: string]: string } = {
    10: 'isWarning',
    11: 'isWarning'
};

const appActionMap: { [propName: string]: boolean } = {
    pay: true
};
const iconMap: { [propName: string]: string } = {
    3002002: '\uf361'
};

interface Props {
    data: {
        productTitle: string;
        toDate: string;
        fromDate: string;
        createTime: string;
        roomInfo: string;
        _disable: boolean;
    };
}

class HotelGroupClass extends Component<Props> {
    public static formatData = (data: any) => {
        const newData = { ...data };

        if (newData.orderType === 3003001) {
            newData.iconfont = '\uf288';
            newData.title = '酒店-前台买单';
        } else {
            newData.iconfont = iconMap[newData.orderType] ? iconMap[newData.orderType] : '\uf288';
            newData.title = newData.orderTitle ? newData.orderTitle : '酒店-团购';
        }
        newData.iconColor = '#f48221';
        newData._orderStatus = statusMap[newData.status];
        newData.actionInfos = utils.buildActionInfos(newData.appAction, appActionMap);
        newData.roomInfo = buildRoomInfoStr(newData) || '';
        // 价格
        newData.currency = (newData.currency || '').trim();
        newData.fixPrice = utils.fixPrice(newData.price, newData.currency);
        newData.fixConvertPrice = utils.fixPrice(newData.convertPrice);
        return newData;
    };

    public render() {
        const {
            data: { productTitle, toDate, fromDate, createTime, roomInfo, _disable } = {}
        } = this.props;
        const styles = _disable ? disabledStyle : enabledStyle;

        return (
            <View style={styles.left}>
                {Boolean(productTitle) && (
                    <Text style={styles.newOrderTitle} numberOfLines={2}>
                        {productTitle}
                    </Text>
                )}
                {Boolean(fromDate && toDate) && (
                    <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                        {fromDate}
                        &nbsp;至&nbsp;
                        {toDate}
                        &nbsp;有效
                    </Text>
                )}
                {Boolean(createTime) && (
                    <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                        下单时间&nbsp;&nbsp;
                        {createTime}
                    </Text>
                )}
                <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                    {roomInfo}
                </Text>
            </View>
        );
    }
}

export default HotelGroupClass;

function buildRoomInfoStr(data: {
    orderType: number;
    ticketCount: number;
    roomTag: string;
    roomType: string;
}) {
    const result = [];
    if (data) {
        // data.orderType === 3003001
        //     ? ''
        //     : data.ticketCount && result.push(`数量${data.ticketCount}  `);
        data.orderType !== 3003001 && data.ticketCount && result.push(`数量${data.ticketCount}  `);
        data.roomTag && result.push(`${data.roomTag}  `);
        data.roomType && result.push(data.roomType);
    }
    return result.join(' ');
}
